import { EDIT_COMMUNITY_RESPONSE } from 'constants/sidebars';
import { useInfoPopup } from 'hooks';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { doDeleteCommunityResponse } from 'store/actionCreators/currentCommunity';
import { openModal } from 'store/actionCreators/modal';
import { EventResponse } from 'types';

export const useResponses = (communityId) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { showInfoPopup } = useInfoPopup();

  const onAdd = () =>
    dispatch(
      openModal({
        type: EDIT_COMMUNITY_RESPONSE,
        placement: 'right',
      }),
    );

  const onEdit = (defaultValues: EventResponse) =>
    dispatch(
      openModal({
        type: EDIT_COMMUNITY_RESPONSE,
        placement: 'right',
        data: defaultValues,
      }),
    );

  const onDelete = (id) =>
    dispatch(
      doDeleteCommunityResponse({
        communityId,
        id,
        onSuccess: () =>
          showInfoPopup({
            type: 'success',
            title: t('common.deleteSuccess.title'),
            message: t('common.deleteSuccess.message'),
            loop: false,
            noButton: true,
            duration: 3000,
          }),
      }),
    );

  return {
    onDelete,
    onAdd,
    onEdit,
  };
};
